module.exports = __webpack_public_path__ + "img/health5_7-9-2021.d4b2e76c.jpg";